import { createSelector } from '@reduxjs/toolkit';
import { DefaultRootState } from 'react-redux';
import { Definition, Modifier } from '../types/diagnostic';

export const diagnosticSelector = ({ diagnostic }: DefaultRootState) =>
  diagnostic;

export const diagnosticsSelector = createSelector(
  diagnosticSelector,
  ({ diagnostics }) => diagnostics,
);

export const currentDiagnosticIndexSelector = createSelector(
  diagnosticSelector,
  ({ currentDiagnosticIndex }) => currentDiagnosticIndex,
);

export const definitionsSelector = createSelector(
  diagnosticSelector,
  ({ definitions }) => definitions,
);

export const primaryDefinitionsSelector = createSelector(
  diagnosticSelector,
  ({ primaryDefinitions }) => primaryDefinitions,
);

export const modifiersByCodeSelector = createSelector(
  diagnosticSelector,
  ({ definitions, primaryDefinitions }) =>
    [...definitions, ...primaryDefinitions].reduce(
      (acc, definition) => ({
        ...acc,
        [definition.code]: {
          frequency: definition.frequency,
          likelihood: definition.likelihood,
          temporality: definition.temporality,
          localization: definition.localization,
        },
      }),
      {} as Record<string, Pick<Definition, Modifier>>,
    ),
);

export const hasPrimaryDefinitionsSelector = createSelector(
  primaryDefinitionsSelector,
  (primaryDefinitions) => primaryDefinitions.length > 0,
);

export const definitionsLoadedSelector = createSelector(
  definitionsSelector,
  (definitions) => definitions.length > 0,
);

export const diagnosticsCountSelector = createSelector(
  diagnosticsSelector,
  (diagnostics) => diagnostics.length,
);

export const currentDiagnosticSelector = createSelector(
  diagnosticsSelector,
  currentDiagnosticIndexSelector,
  (diagnostics, index) =>
    index < diagnostics.length ? diagnostics[index] : null,
);
